import { createAction } from 'redux-actions';
import * as sectors from '../api/sectors';
import { actionTypes } from './index';
import { addNotification } from './api-notifications';

export const sectorsRequest = createAction(actionTypes.GET_SECTORS_REQUSET);
export const sectorsSuccess = createAction(actionTypes.GET_SECTORS_SUCCESS);
export const sectorsError = createAction(actionTypes.GET_SECTORS_FAILURE);

export const fetchSectors = () => async (dispatch, getState) => {
  const { loggedInUser: { userAuth } } = getState();
  dispatch(sectorsRequest());
  try {
    const response = await sectors.fetchSectors(userAuth);
    dispatch(
      sectorsSuccess({
        sectors: response,
        loadnig: false,
        error: false,
      }),
    );
  } catch (err) {
    dispatch(addNotification(err));
    dispatch(
      sectorsError({
        sectors: [],
        loading: false,
        error: true,
      }),
    );
  }
};



// WEBPACK FOOTER //
// ./actions/sectors.js